// @flow
import { createSelector } from "reselect"

import Formatter from "common/services/formatters/Formatter"
import { getLanguageInfo } from "common/services/staticData/index"
import { getTranslations } from "common/services/intl"

// $FlowFixMe
export default createSelector(
  [getTranslations, getLanguageInfo],
  (translations, languageInfo) => new Formatter(translations, languageInfo),
)
